import ProductTeaser from '../product-teaser/product-teaser';
import {
  dispatchCustomEvent,
  detectMobile,
  debounceEvent,
} from '../../../js/utils';

export default class CartFlyout {
  constructor() {
    this.cartSelector = '.js-swa-cart-icon';
    this.cartCloseLayer = '.js-swa-cart-close';
  }

  init() {
    this.isMobile = detectMobile();

    const cartSelectorElement = document.querySelectorAll(this.cartSelector);
    const cartCloseSelectorElement = document.querySelectorAll(
      this.cartCloseLayer
    );
    const cartIconUnderlined = document.querySelector('.swa-header__cart-icon');
    const cartIconUnderlinedSticky = document.querySelector(
      '.swa-header__sticky-cart-icon'
    );
    const headerOverlay = document.querySelector('.swa-header__overlay');

    if (!cartSelectorElement) {
      return;
    }

    this.addWindowResizeListener();
    this.addCloseCartListenerDesktop();


    // cart layer actions only for Patternlab, because in hybris cart is opened only when user is adding an item in the basket, otherwise, at click, if there are items in the basket, it will redirect to shopping bag page
    if (document.querySelector('.js-patternlab-page')) {
      // show cartLayer
      cartSelectorElement.forEach(item => {
        item.addEventListener('mouseenter', () => {
          this.showCartAnimation();
          this.showCartLayer();
          if (cartIconUnderlined || cartIconUnderlinedSticky) {
            cartIconUnderlined.classList.add('swa-active');
            cartIconUnderlinedSticky.classList.add('swa-active');
            headerOverlay && headerOverlay.classList.add('swa-active');
          }
        });
      });

      // close the cartLayer at click on "x"
      cartCloseSelectorElement.forEach(item => {
        item.addEventListener('click', () => {
          this.closeCartLayer();
          this.hideHeaderLogoSmall();
        });
      });

      // if mobile and cart layer opened, at click on search icon, close cart layer
      if (this.isMobile) {
        let searchIcons = document.querySelectorAll('.js-swa-search-layer-icon');
        searchIcons.forEach((searchIcon) => {
        searchIcon.addEventListener('click', () => {
            const cartContainer = document.querySelector('.swa-header__flyout-container');
            if (cartContainer.classList.contains('fade-inCart')) {
              this.closeCartLayer();
              this.hideHeaderLogoSmall();
            }
          });
        });
      }

      this.cartListenersMobile();
    }

    // it will be triggered from hybris
    document.addEventListener('cartAjaxDone', () => {
      this.showCartLayer();
      this.showCartAnimation();
      this.showHeaderLogoSmall();
    });
  }

  showHeaderLogoSmall() {
    const header = document.querySelector('.swa-header');
    const transparentHeader = document.querySelector(
      '.js-swa-header-transparent'
    );

    if (detectMobile() && transparentHeader) {
      header.classList.add('swa-header--sticky');
      header.classList.add('swa-header--solid');
      header.classList.remove('swa-header--transparent');

      const logoImage = document.querySelector(
        '.swa-header__compressed .swa-link__image--logo-mobile--default'
      );

      if (logoImage) {
        logoImage.src = logoImage.dataset.hover;
      }
    }
  }
  hideHeaderLogoSmall() {
    const header = document.querySelector('.swa-header');
    const transparentHeader = document.querySelector(
      '.js-swa-header-transparent'
    );

    if (detectMobile() && transparentHeader) {
      const mainNavigationHeight = 39;
      const stickyHeaderPositionTriggerSmall = 50 - mainNavigationHeight;
      let updatedScrollPosition = 0;

      updatedScrollPosition = window.pageYOffset;

      if (updatedScrollPosition < stickyHeaderPositionTriggerSmall) {
        header.classList.remove('swa-header--sticky');
        header.classList.remove('swa-header--solid');
        header.classList.add('swa-header--transparent');

        //If the small logo header transparent variation on mobile/tablet, use the white logo after closing the cart
        const logoImageSmallMobile = document.querySelector('.swa-header__compressed-logo--show');
        const logoImage = document.querySelector('.swa-header__compressed .swa-link__image--logo-mobile--default');

        if (logoImageSmallMobile && !header.classList.contains('swa-header--transparent-light')) {
          logoImage.src = '/images/icons/swa-brandlogo-icon-big-white.svg';
        }
      }
    }
  }
  cartListenersMobile() {
    const cartSelectorMobileElement = document.querySelector(
      '.swa-header__compressed-cart'
    );

    if (!cartSelectorMobileElement) {
      return;
    }

    cartSelectorMobileElement.addEventListener(
      'click',
      this.cartClickMobile.bind(this),
      true
    );
  }

  // cartClickMobile is specific to patternlab
  // in hybris implamentation we show the cart layer only after the addToCart event
  cartClickMobile() {
    const scrollY = window.scrollY;
    const flyoutContainer = document.querySelector(
      '.swa-header__flyout-container'
    );
    const searchFormInput = document.querySelector('.swa-input__search');

    setTimeout(
      function () {
        if (
          flyoutContainer.classList.contains(
            'swa-header__flyout-container--search'
          )
        ) {
          searchFormInput.value = '';
          flyoutContainer.classList.add('swa-hidden');
          flyoutContainer.classList.remove(
            'swa-header__flyout-container--search'
          );
          const body = document.querySelector('body');
          body.style.overflowY = 'auto';
        }
        if (!flyoutContainer.classList.contains('swa-hidden') && !flyoutContainer.classList.contains('fade-outCart')) {
          this.closeCartLayer();
          this.hideHeaderLogoSmall();
        } else {
          this.showCartAnimation();
          this.showCartLayer();
          this.showHeaderLogoSmall();
        }

        if (scrollY > 50) {
          window.scrollTo(0, scrollY);
          this.showHeaderLogoSmall();
        }
      }.bind(this), 0);
  }

  addCloseCartListenerDesktop() {
    const flyoutContainer = document.querySelector(
      '.swa-header__flyout-container'
    );

    if (!flyoutContainer) {
      return;
    }

    if (!this.isMobile) {
      flyoutContainer.addEventListener('mouseleave', this.closeCartLayer);

      //Close cart flyout at click outside of it
      document.addEventListener('click', (event) => {
        if(!event.target.closest('.swa-header__flyout-container')) {
          this.closeCartLayer();
          this.hideHeaderLogoSmall();
        }
      });
    }
  }

  closeCartLayer() {
    const cartContainer = document.querySelector('.swa-header__cart-flyout');
    const flyoutContainer = document.querySelector(
      '.swa-header__flyout-container'
    );
    const searchLayerElement = document.querySelector('.js-swa-search-layer');
    const cartIconUnderlined = document.querySelector('.swa-header__cart-icon');
    const cartIconUnderlinedSticky = document.querySelector(
      '.swa-header__sticky-cart-icon'
    );
    const headerOverlay = document.querySelector('.swa-header__overlay');
    const body = document.querySelector('body');

    if (flyoutContainer.classList.contains('fade-inCart')) {
      flyoutContainer.classList.remove('fade-inCart');
      flyoutContainer.classList.add('fade-outCart');

      //Check if the body has the no scroll class(added when cart flyout is opened), starting from desktop viewport, and remove it
      if (body.classList.contains('swa-no-scroll') && window.innerWidth >= 1025) {
        body.classList.remove('swa-no-scroll');
      }
    }

    // this needs to be in a timeout otherwise the animation it will not work
    setTimeout(() => {
      if (!flyoutContainer.classList.contains('swa-hidden') && !cartContainer.classList.contains('swa-hidden-cart')) {
        flyoutContainer.classList.add('swa-hidden');
        cartContainer.classList.add('swa-hidden-cart');
        if(flyoutContainer.classList.contains('swa-hidden') && (!searchLayerElement || !searchLayerElement.classList.contains('swa-search-layer--visible'))) {
          headerOverlay && headerOverlay.classList.remove('swa-active');
        }
      }
    }, 200);
    if (cartIconUnderlined || cartIconUnderlinedSticky) {
      cartIconUnderlined.classList.remove('swa-active');
      cartIconUnderlinedSticky.classList.remove('swa-active');
    }
  }

  showCartLayer() {
    const flyoutContainer = document.querySelector(
      '.swa-header__flyout-container'
    );
    const cartContainer = document.querySelector('.swa-header__cart-flyout');
    const searchIconUnderlined = document.querySelector(
      '.swa-header__search-icon'
    );
    const searchIconUnderlinedSticky = document.querySelector(
      '.swa-header__sticky-search-icon'
    );
    const header = document.querySelector('.swa-header');
    const body = document.querySelector('body');

    //Check if the body has the no scroll class(added when cart flyout is opened), starting from desktop viewport, and remove it
    if (!body.classList.contains('swa-no-scroll') && window.innerWidth >= 1025) {
      body.classList.add('swa-no-scroll');
    }

    searchIconUnderlined.classList.remove('swa-active');
    searchIconUnderlinedSticky.classList.remove('swa-active');

    flyoutContainer.classList.remove('swa-hidden');
    flyoutContainer.classList.remove('swa-header__flyout-container--search');

    if (cartContainer.classList.contains('swa-hidden-cart')) {
      cartContainer.classList.remove('swa-hidden-cart');
    }

    // this needs to be in a timeout otherwise the animation it will not work
    setTimeout(() => {
      if (flyoutContainer.classList.contains('swa-hidden') && cartContainer.classList.contains('swa-hidden-cart')) {
        flyoutContainer.classList.remove('swa-hidden');
        cartContainer.classList.remove('swa-hidden-cart');
      }

      if (window.isPatternlabCartLayoutinitialized) {
        //return if PatternlabCartLayout was already Initialized
        return;
      }

      // Product teaser carousel initialization
      window.swaProductTeaser = [];
      cartContainer
        .querySelectorAll('.js-swa-product-teaser')
        .forEach(carouselElement => {
          new ProductTeaser(carouselElement).init();
        });
      document.productTeaserClass = ProductTeaser;
      window.swaProductTeaserInitialized = true;
      dispatchCustomEvent('swaProductTeaserInitialized');

      if (document.querySelector('.js-patternlab-page')) {
        window.isPatternlabCartLayoutinitialized = true;
      }
    }, 200);
  }

  showCartAnimation() {
    const flyoutContainer = document.querySelector(
      '.swa-header__flyout-container'
    );

    if (!flyoutContainer.classList.contains('fade-inCart')) {
      flyoutContainer.classList.remove('fade-outCart');
      flyoutContainer.classList.add('fade-inCart');
    }
  }

  addWindowResizeListener() {
    const flyoutContainer = document.querySelector(
      '.swa-header__flyout-container'
    );
    window.addEventListener(
      'resize',
      debounceEvent(() => {
        let currentIsMobile = detectMobile();
        if (this.isMobile != currentIsMobile && this.isMobile) {
          this.isMobile = !this.isMobile;
          this.addCloseCartListenerDesktop();
        } else if (this.isMobile != currentIsMobile && !this.isMobile) {
          this.isMobile = !this.isMobile;
          flyoutContainer.removeEventListener(
            'mouseleave',
            this.closeCartLayer
          );
        }
      }, 250)
    );
  }
}
